module.exports = __webpack_public_path__ + "img/images.9b950bc0.jpg";